import { ChangelogPlatformType } from "@somewear/api";

export enum ChangelogAsyncStatus {
	INITIAL = "initial",
	LOADING = "loading",
	IDLE = "idle",
}

export const lastTimeViewedLatestEntry = "lastTimeViewedLatestEntry";

export const getPlatformMap = (isStaff: boolean = false) => [
	{
		label: "ATAK",
		key: "atak",
		value: ChangelogPlatformType.ATAK,
	},
	{
		label: "iOS",
		key: "ios",
		value: ChangelogPlatformType.IOS,
	},
	{
		label: "Android",
		key: "android",
		value: ChangelogPlatformType.ANDROID,
	},
	{
		label: "Web",
		key: "web",
		value: ChangelogPlatformType.WEB,
	},
	{
		label: "Firmware",
		key: "firmware",
		value: ChangelogPlatformType.FIRMWARE,
	},
	...(isStaff
		? [
				{
					label: "Unreleased",
					key: "unreleased",
				},
			]
		: []),
];
